import { createRouterSelector } from '@townsquare/router/createRouterSelector';

import { useNoOrgExperience } from '@townsquare/org-context';
import { matchRoute } from '@townsquare/router/primitives/match-route';
import { HomepageRoute } from '@townsquare/router/route-types';
import { chatRoute } from '@townsquare/routes/chat';
import { rovoSearchRoute } from '@townsquare/routes/rovo-search-view';
import { searchRoute } from '@townsquare/routes/search';
import { useNoWorkspaceExperience } from '@townsquare/workspace-store';

import { noWorkspaceRoutes, routes } from './routes';

export const useRoute = createRouterSelector<HomepageRoute>(o => o.route as HomepageRoute);

export const useHomeRoutes = () => {
	const noOrgExperience = useNoOrgExperience();
	const noWorkspaceExperience = useNoWorkspaceExperience();
	return noOrgExperience || noWorkspaceExperience ? noWorkspaceRoutes : routes;
};

export const useIsOnFullscreenChat = () => {
	const matchedRoute = matchRoute(routes, window.location.pathname);
	return matchedRoute && matchedRoute.route?.name === chatRoute.name;
};

export function useIsOnFullscreenSearch(): boolean {
	const matchedRoute = matchRoute(routes, window.location.pathname);

	return matchedRoute?.route?.name === searchRoute.name;
}

export function useIsOnRovoSearch(): boolean {
	const matchedRoute = matchRoute(routes, window.location.pathname);

	return matchedRoute?.route?.name === rovoSearchRoute.name;
}
